import _ from 'lodash';
export const DEFAULT_EMBED_URL_QUERY_PARAM_TEMPLATE = '{ts-query-params}';
export const addQueryParamsToUrlTemplate = (urlTemplate, queryParams) => {
    if (_.isNil(urlTemplate) ||
        _.isNil(queryParams) ||
        !urlTemplate.includes(DEFAULT_EMBED_URL_QUERY_PARAM_TEMPLATE)) {
        return urlTemplate;
    }
    return Object.entries(queryParams).reduce((currUrl, [key, value]) => {
        if (!_.isNil(value)) {
            return currUrl.replace(DEFAULT_EMBED_URL_QUERY_PARAM_TEMPLATE, `${key}=${value}&${DEFAULT_EMBED_URL_QUERY_PARAM_TEMPLATE}`);
        }
        return currUrl;
    }, urlTemplate);
};
export const cleanupQueryParamsTemplateFromUrl = (urlTemplate) => {
    if (_.isNil(urlTemplate)) {
        return urlTemplate;
    }
    return urlTemplate
        .replace(`&${DEFAULT_EMBED_URL_QUERY_PARAM_TEMPLATE}`, '')
        .replace(`?${DEFAULT_EMBED_URL_QUERY_PARAM_TEMPLATE}`, '')
        .replace(DEFAULT_EMBED_URL_QUERY_PARAM_TEMPLATE, '');
};
//# sourceMappingURL=embed-url.util.js.map